export default function FAQ() {
  const qas = [
    ['Do I need an appointment?', 'Appointments are recommended to ensure availability.'],
    ['What ID do I need?', 'A government-issued photo ID is required.'],
    ['How long does Live Scan take?', 'Typically 15–20 minutes.'],
    ['Is my data secure?', 'We follow strict security practices and compliance.']
  ]
  return (
    <div className="max-w-3xl mx-auto px-6 py-12">
      <h2 className="text-4xl font-bold mb-6">FAQ</h2>
      <div className="space-y-3">
        {qas.map(([q,a])=> (
          <details key={q} className="card">
            <summary className="font-semibold">{q}</summary>
            <p className="mt-2 text-muted">{a}</p>
          </details>
        ))}
      </div>
    </div>
  )
}
